// The exact bundle-to-store field mapping `loadFixtures` writes when it
// hydrates a built `FixtureBundle`. Extracted to a single source of truth so
// `loadFixtures`, tests, and any future tooling never re-derive (and
// therefore never drift on) this mapping.

import type { FixtureBundle } from '@/data/fixtures';

/** The state slice `loadFixtures` writes for a built bundle. */
export function fixtureBundleToState(f: FixtureBundle) {
  const customerIdsByPhone: Record<string, string> = {};
  for (const id of Object.keys(f.customers)) {
    customerIdsByPhone[f.customers[id]!.phone.replace(/\s+/g, '')] = id;
  }
  return {
    // rolePermissions intentionally omitted — config, not fixture data; survives loadFixtures.
    initialised: true,
    customers: f.customers,
    customerIdsByPhone,
    bookings: f.bookings,
    deposits: f.deposits,
    topupPlans: f.topupPlans,
    waivers: f.waivers,
    pieces: f.pieces,
    futureSignals: f.futureSignals,
    selfBookLinks: f.selfBookLinks,
    marketingCampaigns: f.marketingCampaigns,
    confirmationCalls: f.confirmationCalls,
    internalComms: f.internalComms,
    internalDmThreads: f.internalDmThreads,
    rebookFollowupTasks: f.rebookFollowupTasks,
    healingCheckTasks: f.healingCheckTasks,
    overrideRequests: f.overrideRequests,
    noRebookFlags: f.noRebookFlags,
    reconResolutions: {},
    sequenceState: f.sequenceState,
    salePayments: f.salePayments,
    payoutRecords: f.payoutRecords,
    cashLedgers: f.cashLedgers,
    merchItems: f.merchItems,
    docketLines: f.docketLines,
    settlementLandings: f.settlementLandings,
    depositLandings: f.depositLandings,
    settlementLumps: f.settlementLumps,
    dayPacks: f.dayPacks,
    studios: f.studios,
    artists: f.artists,
    agents: f.agents,
    tailRecords: f.tailRecords,
    activityFeed: f.activityFeed,
    todayStats: f.todayStats,
  };
}
